// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import ValorizacionDetalle from '../../components/administration/valuations/ValuationDetail'

const ValorizacionDetallePage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <ValorizacionDetalle
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de ordenes de valorizaion detalle:', newOrder);
                }}
            />
        </Box>
    );
};

export default ValorizacionDetallePage;
